import type { ReactNode } from 'react';

interface SettingsScopeSectionProps {
  /** Scope name shown as the section header (e.g. "You", "This campaign", "Admin"). */
  title: string;
  /** Optional supporting line under the header — used to name the selected campaign. */
  description?: ReactNode;
  children: ReactNode;
}

/**
 * A single ownership-scope band on the Settings hub. Each scope (You / This
 * campaign / Admin) is a stacked page section with a visible header, not a
 * nested route — the hub is one page organized by scope.
 */
export function SettingsScopeSection({ title, description, children }: SettingsScopeSectionProps) {
  return (
    <section className="space-y-4">
      <div className="border-b pb-2">
        <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
        )}
      </div>
      {children}
    </section>
  );
}
